import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';
import { getUser, signIn as sendSignInRequest } from '../api/auth';
import type { User, AuthContextType } from '../types';

function AuthProvider(props: React.PropsWithChildren<unknown>) {
  const [user, setUser] = useState<User>();
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    (async function () {
      
      await RetrieveCurrentUser();
      
      setLoading(false);
    })();
  }, []);

  async function RetrieveCurrentUser(){
    const userResult = await getUser();
    if (userResult.isOk) {
      setUser({
        name: String(userResult.data?.givenName),
        email: String(userResult.data?.email)
      });
    }
  }

  const signIn = useCallback(async (email: string, password: string, rememberMe:boolean|undefined) => {
    const result = await sendSignInRequest(email, password);
    if (result.isOk) {
      CurrentToken = String(result.data?.token);
      await RetrieveCurrentUser();

      if (rememberMe){
        localStorage.setItem("token", result.data?.token??"");
      }
    }

    return result;
  }, []);

  const signOut = useCallback(() => {
    setUser(undefined);
    CurrentToken = null;
    localStorage.removeItem("token");
  }, []);


  return (
    <AuthContext.Provider value={{ user, signIn, signOut, loading }} {...props} />
  );
}

const AuthContext = createContext<AuthContextType>({ loading: false } as AuthContextType);
const useAuth = () => useContext(AuthContext);
var CurrentToken:string|null=null;

if (!CurrentToken && localStorage.getItem('token'))
  CurrentToken=localStorage.getItem('token');

export { AuthProvider, useAuth, CurrentToken }
